// extracted by mini-css-extract-plugin
export default {"page":"Sections_page__9dJVu","pricingSection":"Sections_pricingSection__02jAQ"};